import api from './config';

export const createActivity = async (name) => {
    try {
        const token = localStorage.getItem('token');
        if (!token) {
            throw new Error('No authentication token found');
        }

        const response = await api.post('/activity', { name: name }, {
            headers: {
                'Authorization': `Bearer ${atob(token)}` // Decode base64 token
            }
        });

        if (response.data.id == null) {
            throw Error("Could create activity");
        }

        return response.data.id;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const getActivitySummary = async () => {
    try {
        const token = localStorage.getItem('token');
        if (!token) {
            throw new Error('No authentication token found');
        }

        const response = await api.get('/activity/summary', {
            headers: {
                'Authorization': `Bearer ${atob(token)}` // Decode base64 token
            }
        });

        return response.data.activity_summaries;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const getActivity = async (activityId) => {
    try {
        const token = localStorage.getItem('token');
        if (!token) {
            throw new Error('No authentication token found');
        }

        const response = await api.get(`/activity/${activityId}`, {
            headers: {
                'Authorization': `Bearer ${atob(token)}`
            }
        });

        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const updateActivity = async (activityId, name) => {
    try {
        const token = localStorage.getItem('token');
        if (!token) {
            throw new Error('No authentication token found');
        }

        await api.patch(`/activity/${activityId}`, { name }, {
            headers: {
                'Authorization': `Bearer ${atob(token)}`
            }
        });
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const deleteActivity = async (activityId) => {
    try {
        const token = localStorage.getItem('token');
        if (!token) {
            throw new Error('No authentication token found');
        }

        const response = await api.delete(`/activity/${activityId}`, {
            headers: {
                'Authorization': `Bearer ${atob(token)}`
            }
        });

        if (response.status !== 200) {
            throw new Error('Failed to delete activity');
        }
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const getActivityExtensions = async (activityId) => {
    try {
        const token = localStorage.getItem('token');
        if (!token) {
            throw new Error('No authentication token found');
        }

        const response = await api.get(`/activity/${activityId}/extensions`, {
            headers: {
                'Authorization': `Bearer ${atob(token)}`
            }
        });

        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const getAvailableExtensions = async (activityId) => {
    try {
        const token = localStorage.getItem('token');
        if (!token) {
            throw new Error('No authentication token found');
        }

        const response = await api.get(`/activity/${activityId}/extensions/available`, {
            headers: {
                'Authorization': `Bearer ${atob(token)}`
            }
        });

        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const addExtensionToActivity = async (activityId, extensionId) => {
    try {
        const token = localStorage.getItem('token');
        if (!token) {
            throw new Error('No authentication token found');
        }

        const response = await api.post(`/activity/${activityId}/extensions`, { extensionId }, {
            headers: {
                'Authorization': `Bearer ${atob(token)}`
            }
        });

        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const getCalendarActivities = async (params) => {
    try {
        const token = localStorage.getItem('token');
        if (!token) {
            throw new Error('No authentication token found');
        }

        const response = await api.get('/activity/calendar', {
            params,
            headers: {
                'Authorization': `Bearer ${atob(token)}`
            }
        });

        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};